export default __webpack_public_path__ + "static/media/D0400.34I-39598_-26865_0.d19147a4.jpg";